export { default } from './Tags';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Tags/index.js